import {sort} from 'timsort'

type RigState = State & {
    items: any[]
}

export default function rigStateReducer(
    state: RigState = {
        start: {info: {span: {normalized: ''}}},
        items: [],
        span: {begin: 0, end: 0}
    },
    event: Event
): State {
    if (!event) {
        return state;
    }
    if ((event.baseline && event.type != 'event') || event.layer > 0) {
        return state;
    }

    switch (event.type) {
        case 'start':
            return {
                ...state,
                start: event.events,
                items: []
            } as RigState
        case 'span':
            state.span = event.events;
            // TODO: remove items (+1) events.
            return state;
        case 'event':
            if (event.events.length == 0) {
                return state
            }
            state.items = state.items.concat(event.events)
            sort(state.items, (a: DataEvent, b: DataEvent) => a.timestamp - b.timestamp)
            return state;
        default:
            return state
    }
}
